import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierMinusFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.247.497c-5.063 0-6.75 3.375-6.75 6.75s1.687 6.75 6.75 6.75c1.952 0 3.402-.502 4.448-1.313L14.51 15.5l.99-.99-2.822-2.822c.94-1.24 1.319-2.84 1.319-4.441 0-3.375-1.688-6.75-6.75-6.75m3.25 7.453v-1.4h-6.5v1.4z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MagnifierMinusFilledSize16Glyph.displayName = 'MagnifierMinusFilledSize16Glyph';
